import { useRequestTraceId } from '@bees-web/core/shared/contexts'
import { useCallback, useRef } from 'react'
import useSWR, { SWRResponse } from 'swr'

import httpClient, { HttpClientOptions } from '@/core/clients/httpClient'
import { RequestHeaders } from '@/core/types'

const useFetch = <T>(url: string, headers?: RequestHeaders): SWRResponse<T> => {
  const requestTraceId = useRequestTraceId()

  const headersRef = useRef(headers)
  headersRef.current = headers
  const traceIdRef = useRef(requestTraceId)
  traceIdRef.current = requestTraceId

  const fetcher = useCallback(async (fetchUrl: string): Promise<T> => {
    const h = headersRef.current
    const traceId =
      h?.requestTraceId ??
      `${traceIdRef.current}:${fetchUrl.split('/').pop()?.split('?')[0]}`

    const options: HttpClientOptions = {
      ...(h ? { headers: h } : {}),
      requestTraceId: traceId,
    }

    return await httpClient<T>(options)(fetchUrl)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return useSWR<T>(url, fetcher)
}

export default useFetch
